import React, { useRef, useState } from 'react';
import { Button, Checkbox, Popup } from '@ui';
/**
 * Building's two bulk actions, rendered by the shared `AttachmentsToolbar` before its Delete
 * button. Presentational: it owns only its two popovers' open/closed UI state and calls back up to
 * `useAttachmentBulkEdits`'s mutation handlers.
 */
export function BuildingAttachmentsBulkActions({ updateCategoryLabel, updateVisibilityLabel, categoryOptions, showVisibilityAction, techCheckboxLabel, techChecked, techIndeterminate, visibilityCheckboxLabel, visibilityChecked, visibilityIndeterminate, disabled, onUpdateCategory, onUpdateTechVisibility, onUpdateVisibility }) {
    const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
    const [isVisibilityMenuOpen, setIsVisibilityMenuOpen] = useState(false);
    const categoryButtonRef = useRef(null);
    const visibilityButtonRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: categoryButtonRef, isMenu: true, disabled: disabled, onClick: () => setIsCategoryMenuOpen((prev) => !prev) },
            React.createElement("i", { className: "fa-light fa-folder", "aria-hidden": "true" }),
            " ",
            updateCategoryLabel),
        React.createElement(Popup, { anchor: categoryButtonRef.current, show: isCategoryMenuOpen, onClose: () => setIsCategoryMenuOpen(false), position: "bottom-left", containerClass: "qmb-ui-popup--action-list attachments-toolbar__category-menu" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true }, categoryOptions.map((option) => {
                    var _a;
                    return (React.createElement(Button, { key: (_a = option.id) !== null && _a !== void 0 ? _a : 'uncategorized', type: "button", onClick: () => {
                            setIsCategoryMenuOpen(false);
                            onUpdateCategory(option.id);
                        } }, option.label));
                })))),
        React.createElement(Button, { ref: visibilityButtonRef, isMenu: true, disabled: disabled, onClick: () => setIsVisibilityMenuOpen((prev) => !prev) },
            React.createElement("i", { className: "fa-light fa-eye", "aria-hidden": "true" }),
            " ",
            updateVisibilityLabel),
        React.createElement(Popup, { anchor: visibilityButtonRef.current, show: isVisibilityMenuOpen, onClose: () => setIsVisibilityMenuOpen(false), position: "bottom-left", containerClass: "qmb-ui-popup--action-list attachments-toolbar__visibility-menu" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true },
                    React.createElement(Checkbox, { id: "attachments-mass-actions-visibility-tech", checked: techChecked, indeterminate: techIndeterminate, label: techCheckboxLabel, onChange: (checked) => {
                            setIsVisibilityMenuOpen(false);
                            onUpdateTechVisibility(checked);
                        } }),
                    showVisibilityAction && (React.createElement(Checkbox, { id: "attachments-mass-actions-visibility-portal", checked: visibilityChecked, indeterminate: visibilityIndeterminate, label: visibilityCheckboxLabel, onChange: (checked) => {
                            setIsVisibilityMenuOpen(false);
                            onUpdateVisibility(checked);
                        } })))))));
}
